import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PeerGroups } from '../enums';
import { PeerComparisonGroup } from '../models/peer-comparison-group';
import { PeerComparisonGroupBuilder } from '../models/peer-comparison-group.builder';

@Injectable({
	providedIn: 'root'
})
export class PeerComparisonGroupService {

	public getPeerComparisonGroups(): Observable<PeerComparisonGroup[]> {
		return new Observable<PeerComparisonGroup[]>(observer => {
			const peerComparisonGroups: PeerComparisonGroup[] = Object.keys(PeerGroups).map(group => {
				return new PeerComparisonGroupBuilder().setByGroupName(group).build();
			});
			observer.next(peerComparisonGroups);
		});
	}
}
